import { DateTime } from 'luxon';
import * as marked from 'marked';

import AnnouncementTargetedOrgType from '@/common/models/announcements/AnnouncementTargetedOrgType';
import AnnouncementType from '@/common/models/announcements/AnnouncementType';

interface IFeatureAnnouncementAPI {
  announcement_id: number;
  date_from_utc: string;
  date_to_utc: string;
  description: string;
  image_url: string;
  name: string;
  redirection_url: string;
  targeted_org_type: string;
  title: string;
  type: string;
}

export default class Announcement {
  id: number;

  dateFromUtc: DateTime;

  dateToUtc: DateTime;

  description: string;

  imageUrl: string;

  name: string;

  redirectionUrl: string;

  targetedOrgType: AnnouncementTargetedOrgType;

  title: string;

  type: AnnouncementType;

  wasRead: boolean;

  constructor(
    id = -1,
    dateFromUtc: DateTime,
    dateToUtc: DateTime,
    description: string,
    imageUrl: string,
    name: string,
    redirectionUrl: string,
    // Note that announcements targeting a supply or demand org are filtered by the API.
    targetedOrgType: AnnouncementTargetedOrgType,
    title: string,
    type: AnnouncementType,
  ) {
    this.id = id;
    this.name = name;
    this.dateFromUtc = dateFromUtc;
    this.dateToUtc = dateToUtc;
    this.description = description;
    this.imageUrl = imageUrl;
    this.name = name;
    this.redirectionUrl = redirectionUrl;
    this.targetedOrgType = targetedOrgType;
    this.title = title;
    this.type = type;
    this.wasRead = false;
  }

  static fromApi(apiObject: IFeatureAnnouncementAPI): Announcement {
    return new Announcement(
      apiObject.announcement_id,
      DateTime.fromISO(apiObject.date_from_utc, { zone: 'utc' }),
      DateTime.fromISO(apiObject.date_to_utc, { zone: 'utc' }),
      apiObject.description,
      apiObject.image_url,
      apiObject.name,
      apiObject.redirection_url,
      apiObject.targeted_org_type as AnnouncementTargetedOrgType,
      apiObject.title,
      apiObject.type as AnnouncementType,
    );
  }

  get descriptionHTML() {
    return marked.parse(this.description);
  }
}
